export function AppSection() {
  return (
    <section id="app" className="py-14 md:py-16 px-4 md:px-8 bg-accent-500">
      <div className="max-w-[900px] mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-white">
          移动端观影入口
        </h2>
        <p className="text-sm text-white/80 mt-2 mb-8 max-w-xl mx-auto leading-relaxed">
          随时随地畅享高清电影。通过手机浏览器访问6080电影网，即享与PC端一致的高清流畅观影体验，
          支持横屏全屏播放，流量消耗低，地铁通勤、旅途间隙，精彩电影随时相伴。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <div className="bg-white/15 backdrop-blur rounded-xl p-5 border border-white/20 text-left w-full sm:w-auto">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center flex-shrink-0">
                <i className="ri-smartphone-line text-xl text-accent-600"></i>
              </div>
              <div>
                <div className="text-white font-semibold text-sm">手机浏览器访问</div>
                <div className="text-white/60 text-xs">m.6080dy.com</div>
              </div>
            </div>
          </div>
          <div className="bg-white/15 backdrop-blur rounded-xl p-5 border border-white/20 text-left w-full sm:w-auto">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-white flex items-center justify-center flex-shrink-0">
                <i className="ri-qr-code-line text-xl text-accent-600"></i>
              </div>
              <div>
                <div className="text-white font-semibold text-sm">扫描二维码直达</div>
                <div className="text-white/60 text-xs">自动适配手机屏幕</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-16 px-4 md:px-8 bg-background-50">
      <div className="max-w-[700px] mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          联系我们
        </h2>
        <p className="text-sm text-foreground-500 mt-2 mb-8 max-w-lg mx-auto leading-relaxed">
          如您有任何观影建议、内容推荐或合作意向，欢迎与我们取得联系。您的反馈是我们不断进步的动力。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="#hero"
            onClick={(e) => e.preventDefault()}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-primary-500 text-white font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-primary-600 transition-colors"
          >
            <i className="ri-mail-line"></i>
            发送邮件
          </a>
          <a
            href="#hero"
            onClick={(e) => e.preventDefault()}
            className="inline-flex items-center gap-2 px-6 py-3 rounded-full border border-background-300 text-foreground-700 font-medium text-sm whitespace-nowrap cursor-pointer hover:bg-background-100 transition-colors"
          >
            <i className="ri-chat-1-line"></i>
            在线留言
          </a>
        </div>
      </div>
    </section>
  );
}

export function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-16 px-4 md:px-8 bg-background-100">
      <div className="max-w-[800px] mx-auto text-center">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
          关于6080电影网
        </h2>
        <p className="text-sm text-foreground-500 mt-2 mb-8 max-w-2xl mx-auto leading-relaxed">
          6080电影网是一个专注于高清电影免费在线观看的综合性影视平台。自上线以来，始终秉承"开放、免费、高清、极速"的核心理念，
          致力于为全球华人观众提供最优质的免费观影体验。我们拥有专业的内容编辑团队和完善的技术架构，
          每日持续更新海量影视资源，涵盖动作、喜剧、科幻、爱情、动画、纪录片等全品类。无论是最新院线大片，
          还是经典高分老片，在6080电影网都能找到。极速秒开、无广告、不缓冲，让每一次观影都成为一种享受。
        </p>
        <div className="flex flex-wrap items-center justify-center gap-8">
          <div className="text-center">
            <div className="font-heading text-2xl md:text-3xl font-bold text-primary-600">5年+</div>
            <div className="text-xs text-foreground-400 mt-1">稳定运营</div>
          </div>
          <div className="text-center">
            <div className="font-heading text-2xl md:text-3xl font-bold text-primary-600">1000万+</div>
            <div className="text-xs text-foreground-400 mt-1">累计用户</div>
          </div>
          <div className="text-center">
            <div className="font-heading text-2xl md:text-3xl font-bold text-primary-600">10万+</div>
            <div className="text-xs text-foreground-400 mt-1">影片总量</div>
          </div>
        </div>
      </div>
    </section>
  );
}